import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  computed,
  signal,
} from '@angular/core';
import { UserInfoComponent } from '../../../../../shared/ui/user-info/user-info.component';
import { RoleInfoComponent } from '../../../../../shared/ui/role-info/role-info.component';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { RolesManagementStore } from '../../store/roles-management.store';
import { SearchBarComponent } from '../../../../../shared/ui/search-bar/search-bar.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { EmptySearchComponent } from '../../../../../shared/ui/empty-search/empty-search.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ADMIN } from '../../../../core/constants';
import { UsersManagementStore } from '../../../users-management/store/users-management.store';
import { IColorOption } from '../../interfaces';
import { TranslationService } from '../../../../shared/services/translation.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-role-users',
  imports: [
    CommonModule,
    UserInfoComponent,
    RoleInfoComponent,
    MatIcon,
    MatButtonModule,
    MatListModule,
    MatChipsModule,
    SearchBarComponent,
    MatMenuModule,
    EmptySearchComponent,
    MatTooltipModule,
  ],
  templateUrl: './role-users.component.html',
  styleUrl: './role-users.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoleUsersComponent {
  readonly store = inject(RolesManagementStore);
  readonly usersStore = inject(UsersManagementStore);
  private readonly translationService = inject(TranslationService);
  readonly ADMIN = ADMIN;
  roleName = input.required<string>();
  icon = input.required<IColorOption>();
  addDisabled = input.required<boolean>();

  private translations = signal({
    searchPeople: 'Search people',
    all: 'All',
    assigned: 'Assigned',
    notAssigned: 'Not assigned',
    assignedUsers: 'Assigned users',
    notAssignedUsers: 'Not assigned users',
    chooseRoleNameFirst: 'Choose a name for this role first',
    add: 'Add',
  });

  readonly searchPeople = computed(() => this.translations().searchPeople);
  readonly all = computed(() => this.translations().all);
  readonly assigned = computed(() => this.translations().assigned);
  readonly notAssigned = computed(() => this.translations().notAssigned);
  readonly assignedUsers = computed(() => this.translations().assignedUsers);
  readonly notAssignedUsers = computed(() => this.translations().notAssignedUsers);
  readonly chooseRoleNameFirst = computed(() => this.translations().chooseRoleNameFirst);
  readonly add = computed(() => this.translations().add);

  constructor() {
    this.loadTranslations();
    this.translationService.getCurrentLanguage$().subscribe(() => {
      this.loadTranslations();
    });
  }

  private loadTranslations() {
    combineLatest([
      this.translationService.getTranslation('searchPeople'),
      this.translationService.getTranslation('all'),
      this.translationService.getTranslation('assigned'),
      this.translationService.getTranslation('notAssigned'),
      this.translationService.getTranslation('assignedUsers'),
      this.translationService.getTranslation('notAssignedUsers'),
      this.translationService.getTranslation('chooseRoleNameFirst'),
      this.translationService.getTranslation('add'),
    ]).subscribe(([searchPeople, all, assigned, notAssigned, assignedUsers, notAssignedUsers, chooseRoleNameFirst, add]) => {
      this.translations.set({
        searchPeople: searchPeople || 'Search people',
        all: all || 'All',
        assigned: assigned || 'Assigned',
        notAssigned: notAssigned || 'Not assigned',
        assignedUsers: assignedUsers || 'Assigned users',
        notAssignedUsers: notAssignedUsers || 'Not assigned users',
        chooseRoleNameFirst: chooseRoleNameFirst || 'Choose a name for this role first',
        add: add || 'Add',
      });
    });
  }


}
